import { Box, Chip, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import GroupsIcon from "@mui/icons-material/Groups";
import { SearchBar } from "src/chamber/features/dashboard/ui/SearchBar";
import ESignatureRedirector from "src/chamber/features/dashboard/ui/ESignatureRedirector";

type TEsignatureProps = {
  ownCount: number | null;
  allCount: number | null;
  countsLoading?: boolean;
};

function ESignature(props: TEsignatureProps) {
  const { t } = useTranslation();
  const { ownCount, allCount, countsLoading } = props;

  const [protocol, setProtocol] = useState("");
  const [gemi, setGemi] = useState("");

  return (
    <>
      <Paper>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem",
          }}
        >
          <Typography
            variant="h5"
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <GroupsIcon />
            {t("Αιτήματα Προσθήκης Νόμιμων Εκπροσώπων")}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 2,
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <SearchBar
            mode={"user"}
            protocol={protocol}
            gemi={gemi}
            setProtocol={setProtocol}
            setGemi={setGemi}
          />
        </Box>
        <Box
          sx={{
            padding: "1rem",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            width: "100%",
            flex: 1,
          }}
        >
          <ESignatureRedirector
            countsLoading={countsLoading}
            activeViolationCasesApplications={ownCount}
            assignChamberAdminDashboard={allCount}
          />
        </Box>
      </Paper>
    </>
  );
}

export default ESignature;
